export var Environment;

(function (Environment) {
  Environment["Dev"] = "dev";
  Environment["Test"] = "test";
  Environment["Preprod"] = "preprod";
  Environment["Prod"] = "prod";
})(Environment || (Environment = {}));

export var Feature;

(function (Feature) {
  Feature["ServiceWorker"] = "serviceWorker";
  Feature["MockAPI"] = "mockAPI";
  Feature["Encryption"] = "encryption";
  Feature["E2EE"] = "E2EE";
})(Feature || (Feature = {}));